import BusinessService from '../../../modules/business/businessService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'BUSINESS_FORM'

const businessFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: businessFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await BusinessService.find(id)
      }

      dispatch({
        type: businessFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: businessFormActions.INIT_ERROR,
      })

      dispatch(push('/business'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: businessFormActions.CREATE_STARTED,
      })

      await BusinessService.create(values)

      dispatch({
        type: businessFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.business.create.success'),
      )

      dispatch(push('/business'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: businessFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: businessFormActions.UPDATE_STARTED,
      })

      await BusinessService.update(id, values)

      dispatch({
        type: businessFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.business.update.success'),
      )

      dispatch(push('/business'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: businessFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default businessFormActions
